import { useEffect, useState } from 'react';
import {
  subscribeUsageHistory,
  type UsageHistoryResult,
} from '@/lib/firestoreTenantDetail';

/**
 * Assina o histórico mensal de uso (etiquetas impressas) de um tenant.
 *
 * Origem: sem issue — commit 3a98de728, 2026-04-26 17:24 +0200 (aba Uso, Sprint 2).
 *
 * Contrato: `LOADING` a cada troca de `tenantId`; `READY` com até 12 meses
 * (`USAGE_HISTORY_LIMIT`), do mais recente para o mais antigo; `ERROR` quando o
 * listener cai. Desassina ao desmontar ou trocar de tenant.
 *
 * Usado por: `features/usage/UsageTab.tsx` (aba Uso de `routes/TenantDetailPage.tsx`).
 *
 * Dados: `tenants/{tenantId}/billing/usage/months/{yyyymm}`, um doc por mês,
 * formato `UsageCountersSchema` (`packages/types/src/schemas.ts`). Doc fora do
 * schema é descartado em `subscribeUsageHistory` (`lib/firestoreTenantDetail.ts`).
 *
 * Dicas: a ordenação é no cliente, não `orderBy(documentId(), 'desc')` — este
 * exigiria índice composto e já derrubou a aba (ver o comentário em
 * `subscribeUsageHistory`).
 */
export function useUsageHistory(tenantId: string): UsageHistoryResult {
  const [state, setState] = useState<UsageHistoryResult>({ kind: 'LOADING' });

  useEffect(() => {
    setState({ kind: 'LOADING' });
    return subscribeUsageHistory(tenantId, setState);
  }, [tenantId]);

  return state;
}
